export default {
    background: "var(--veryDarkBlueB)",
    color: 'white',
    backgroundSecond: "var(--darkBlue)",
 
    
}